import request from '@/utils/request'

// 获取预约送餐列表
export function getMealReservationList(params) {
  return request({
    url: '/syMealReservation/pageList',
    method: 'post',
    data: params
  })
}

// 用户支付订单列表
export function getUnpaidOrders(params) {
  return request({
    url: '/syMealReservation/unpaidOrders',
    method: 'post',
    data: params
  })
}

// 订单退费
export function refundOrder(params) {
  return request({
    url: '/academyMeal/pay/miniProgram/refund',
    method: 'post',
    data: params
  })
}

// 用户创建预约送餐获取key
export function getOrderIdempotencyKey(params) {
  return request({
    url: '/order/idempotency-key',
    method: 'get',
    params
  })
}

// 创建预约送餐
export function createMealReservation(data) {
  return request({
    url: '/syMealReservation/add',
    method: 'post',
    data
  })
}

// 取消预约送餐
export function cancelMealReservation(data) {
  return request({
    url: `/syMealReservation/delete/${data.id}`,
    method: 'delete',
    data
  })
}

// 支付预约送餐订单
export function payMealReservation(data) {
  return request({
    url: '/syMealReservation/pay',
    method: 'post',
    data
  })
}

// 退款预约送餐订单
export function refundMealReservation(data) {
  return request({
    url: '/syMealReservation/refund',
    method: 'post',
    data
  })
}

// 编辑预约送餐
export function updateMealReservation(data) {
  return request({
    url: '/syMealReservation/update',
    method: 'put',
    data
  })
}

// 根据条件查询可选套餐
export function queryMealPackage(data) {
    return request({
      url: '/syMealReservation/getMealPackage',
      method: 'post',
      data
    })
}
// 根据条件查询Org
export function querySyOrgSelectList(data) {
    return request({
      url: '/syOrg/selectList',
      method: 'post',
      data
    })
}

// 根据食谱查询套餐信息

export function queryMealStandardList(data) {
    return request({
      url: '/meal/standard/list',
      method: 'post',
      data
    })
}


// 根据条件查询当日菜品

export function queryStandardMealDishList(data) {
    return request({
      url: '/meal/standard/getMealDishList',
      method: 'post',
      data
    })
}

// 查询时段内是否有配置套餐
export function getDisabledDatesAPI(data) {
  return request({
    url: '/meal/standard/checkSideDish',
    method: 'post',
    data
  })
}

// 饮品订单新增
export function addSyDrinkReservation(data) {
  return request({
    url: '/syDrinkReservation/add',
    method: 'post',
    data
  })
}


// 饮品订单修改
export function updateSyDrinkReservation(data) {
  return request({
    url: '/syDrinkReservation/update',
    method: 'put',
    data
  })
}
// 查询饮品分类列表
export function getGroupByTypeSyDrink(data) {
  return request({
    url: '/syDrink/groupByType',
    method: 'post',
    data
  })
}

// 更新饮品状态
export function updateStatusSyDrinkReservation(data) {
  return request({
    url: '/syDrinkReservation/updateStatus',
    method: 'put',
    data
  })
}

// 分页查询饮品订单列表  
export function querySyDrinkPageList(data) {
  return request({
    url: '/syDrinkReservation/pageList',
    method: 'post',
    data
  })
}

// 根据 orderNo 获取订单详情
export function getMealReservationDetail(orderNo) {
  return request({
    url: '/syMealReservation/pageList',
    method: 'post',
    data: {
      page: { pageIndex: 1, pageSize: 1 },
      orderNo: orderNo
    }
  })
}